/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BreakpointsBucket } from './BreakpointsBucket';
import type { CapTableBucket } from './CapTableBucket';
import type { CashFlowsBucket } from './CashFlowsBucket';
import type { DocumentsProcessManagementBucket } from './DocumentsProcessManagementBucket';
import type { FinancialsBucket } from './FinancialsBucket';
import type { OwnershipBucket } from './OwnershipBucket';
import type { ValuationAllocationBucket } from './ValuationAllocationBucket';
export type LookingGlassSnapshot = {
  readonly id?: number;
  readonly firm_id?: string;
  readonly fund_id?: string;
  readonly company_id?: string;
  readonly security_id?: string;
  readonly measurement_date_id?: string;
  /**
   * Denormalized date from MeasurementDate. Partition key.
   */
  readonly measurement_date_value?: string;
  readonly fund_name?: string;
  readonly company_name?: string;
  readonly security_name?: string;
  /**
   * Granularity level: firm, fund, fund_rollup, company, company_rollup, or security.
   */
  readonly row_type?: LookingGlassSnapshot.row_type;
  cap_table?: CapTableBucket;
  financials?: FinancialsBucket;
  ownership?: OwnershipBucket;
  breakpoints?: BreakpointsBucket;
  cash_flows?: CashFlowsBucket;
  valuation_allocation?: ValuationAllocationBucket;
  documents_process_management?: DocumentsProcessManagementBucket;
  readonly created_at?: string;
  readonly updated_at?: string;
};
export namespace LookingGlassSnapshot {
  /**
   * Granularity level: firm, fund, fund_rollup, company, company_rollup, or security.
   */
  export enum row_type {
    FIRM = 'firm',
    FUND_ROLLUP = 'fund_rollup',
    COMPANY = 'company',
    COMPANY_ROLLUP = 'company_rollup',
    COMPANY_INVESTMENT = 'company_investment',
  }
}

